import { Component, Input } from '@angular/core';
import { RelatedSearchService } from '../related.search.service';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'related-result-list',
  template: require('./related-result-list.component.html')
})
export class RelatedResultListComponent {
  @Input() results: any[];

  constructor(private relatedSearchService: RelatedSearchService, private stateService: StateService) {}

  goTo(result: any) {
    this.relatedSearchService.getDestinationState(result)
      .then((data: any) => {
        this.stateService.go(data.state, data.params, data.options);
      });
  }
}
